import HeroBanner from './HeroBanner'

export default HeroBanner
